import type {CurrencyData} from '@rubyplay/currency-formatter';

export type CurrencyConfiguration = {
    currencyCode: string;
    fractionSize: number;
    localeCode: string;
    secondaryCurrencyCode?: string;
};

export interface ICurrencyFormatter {
    fractionSize: number;

    currencyCode: string;

    secondaryCurrencyCode: string;

    setCurrencyData(currencyCode: string, data: CurrencyData): void;

    getCurrencyData(currencyCode: string): CurrencyData|undefined;

    setParameters(config: CurrencyConfiguration): void;

    formatCents(cents: number): string;

    format(value: number): string;
}
